var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.995 10.162L22.749 0h-2.075l-7.6 8.824L7.001 0H0l9.18 13.343L0 24h2.075l8.026-9.318L16.514 24h7.002l-9.52-13.838zm-2.842 3.299l-.93-1.329L2.822 1.56h3.186l5.973 8.532.93 1.329 7.764 11.09H17.49l-6.336-9.05z",
    fill: "#fff"
  })));
}
export default SvgTwitter;